import BaseFormPresenter from "../../../../components/common/BaseFormPresenter";
import { v4 as uuidv4 } from "uuid";

class IncentiveFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  async submit() {
    const { incentive } = this.view.state;
    const currAllowanceType = this.change?.allowanceType?.AllowanceType;

    const isDuplicate = incentive.some(
      (item) => item.allowanceType === currAllowanceType
    );

    if (isDuplicate) {
      this.showError("Allowance type already exist!");
    } else {
      if (Object.values(this.change).length === 0) {
        this.showSuccess("Successfully Saved!");
        return;
      }
      
      const recordId = this.object?.id || this.change?.id || uuidv4();
      
      const incentiveData = {
        ...this.object,  
        ...this.change,  
        id: recordId,
      };
      
      const payItemsData = {
        id: recordId,
        name: this.change?.allowanceType?.AllowanceType || this.object?.allowanceType?.AllowanceType,
        isIncentive: true,
      };
      
      try {
        await this.upsertUseCase.execute("incentive", incentiveData);
        await this.upsertUseCase.execute("pay_items", payItemsData);
        this.showSuccess("Successfully Saved!");
      } catch (error) {
        this.view.showError(error);
      }
    }
  }
}

export default IncentiveFormPresenter;
